var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"land-flats-aqualina-apart active"},[_c('flatsFilter'),_c('flatsCards')],1)}
var staticRenderFns = []

export { render, staticRenderFns }